import { DisconnectOutlined, DiscordOutlined, HistoryOutlined, HomeOutlined, LogoutOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Navbar.css';

const links = [
    { to: '/', label: 'Dashboard', icon: <HomeOutlined /> },
    { to: '/app/players', label: 'Players', icon: <DisconnectOutlined /> },
    { to: '/app/inventory', label: 'Inventory', icon: <UnorderedListOutlined /> },
    { to: '/app/history', label: 'Hatch History', icon: <HistoryOutlined /> },
    { to: '/app/serverselect', label: 'Server', icon: <DiscordOutlined /> },
];

const logout = (e) => {
    e.preventDefault();
    localStorage.removeItem('selectedServer');
    window.location.href = 'https://huge-notifier.haxixu.xyz/api/logout';
};

const NavbarComponent = () => {
    const { pathname } = useLocation();

    return (
        <nav className="navbar">
            <Link to="/" className="navbar-brand">
                <span className="navbar-brand-mark" aria-hidden="true" />
                Huge Notifier
            </Link>
            <div className="navbar-links">
                {links.map((link) => (
                    <Link
                        key={link.to}
                        to={link.to}
                        className={`navbar-link${pathname === link.to ? ' navbar-link-active' : ''}`}
                    >
                        {link.icon}
                        <span>{link.label}</span>
                    </Link>
                ))}
                <a href="/api/logout" onClick={logout} className="navbar-link navbar-link-logout">
                    <LogoutOutlined />
                    <span>Logout</span>
                </a>
            </div>
        </nav>
    );
};

export default NavbarComponent;
